import React from 'react';
import { Box, Typography, Paper, Button, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/** Settings tab that points owners at the Owner Console (OW/sOW only; the tab itself is gated in Settings.js). */
function HiringMarketingLink() {
  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 720 }}>
      <Typography variant="h6" gutterBottom>Hiring and Marketing Management</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Company setup, website services and pricing, memberships, customers and claims, notifications,
        and hiring (job postings, applicants, contract templates and the assessment reviewer link) are
        managed in the Owner Console. It is available to owners only and asks for your password again
        before it opens.
      </Typography>
      <Box>
        <Button variant="contained" component={RouterLink} to="/owner">Click here to open the Owner Console</Button>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
        Prefer a link? <Link component={RouterLink} to="/owner">/owner</Link>
      </Typography>
    </Paper>
  );
}

export default HiringMarketingLink;
